import { useMemo, useState, useRef } from "react";
import { ImageMain } from "../../../components/img/Img.Main";
import {
  STYLE_PADDING_MAIN,
  STYLE_SPACE_GRAY_MENU,
} from "../../../utils/useStyle";
import { CardFutureCheckBox } from "../styles/Card";
import { FutureStepOne } from "./VIFuture_StepOne";
import { MTButton } from "../../../components/button/MTButton";
import { FutureStepTwo } from "./VIFuture_StepTwo";
import { FutureStepThree } from "./VIFuture_StepThree";
import { FooterAfterSum } from "../../../components/FooterAfterSum/FooterAfterSum";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";
import { useRetireStore } from "../../../_store/retireStore";
import _ from "lodash";
import FutureResultTable from "./FutureResultTable";
import { useBalanceStore } from "../../../_store/balanceStore";
import {
  CalcAll_Expense,
  Credit_Debt,
  Short_Term_Debt,
} from "../../../functions/futurePlan/futurePlanFunction";
import { calDebtCreditCard, cn } from "../../../utils/useFunctions";
import { useEducationStore } from "../../../_store/educationStore";
import { key_under_education } from "../../education/functions/options";

const FuturePlan = ({ isPlan, setIsPlan, tab, setTab }) => {
  const retireData = useRetireStore((state) => state.retireData);
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const setFuturePlanData = useFuturePlanStore(
    (state) => state.setFuturePlanData
  );
  const educationData = useEducationStore((state) => state.educationData);

  const balanceData = useBalanceStore((state) => state?.balanceData);
  const setBalanceData = useBalanceStore((state) => state?.setBalanceData);

  const [displaySumary, setDisplaySumary] = useState(false);
  const futureResultTableRef = useRef(null);

  const calculateCashFlow = () => {
    let cash_flow_items = [];
    let future_keys = Object.keys(futurePlanData);
    let diff_age = futurePlanData?.age_dead - futurePlanData?.age_current;
    let out_come_stable = futurePlanData?.out_come_stable;
    let sum_expenese_total = 0;
    let sum_income_total = 0;

    const futureMoreKeys = [];
    for (const future_key of future_keys) {
      if (
        futurePlanData[future_key]?.length > 0 &&
        future_key !== "cash_flow_items" &&
        future_key !== "cash_flow_keys"
      ) {
        futureMoreKeys.push(future_key);
      }
    }

    for (let index = 0; index < diff_age + 1; index++) {
      let createItem = {};

      const prev_remain = index === 0 ? 0 : cash_flow_items[index - 1].remain;
      const prev_remain_accumulate =
        index === 0
          ? futurePlanData?.income_investment
          : cash_flow_items[index - 1].remain_accumulate;

      const re_salary_peryear = futurePlanData?.salary * 12;
      const re_outcome_peryear = futurePlanData?.out_come * 12;
      const age = futurePlanData?.age_current + index;

      // -----หนี้ระยะสั้น--------
      const debt_short_list = Short_Term_Debt(
        balanceData?.debt_short_list?.find((item) => {
          return item?.options_debt_short === "debt_shortterm";
        }),
        index,
        diff_age + 1
      );
      const debt_creditCard = Credit_Debt(
        balanceData?.debt_short_list
          ?.find((item) => {
            return item?.options_debt_short === "debt_creditcard";
          })
          ?.credit_cards?.map((item2, index2) => {
            let tempCalDebtCreditCard = calDebtCreditCard(item2);

            tempCalDebtCreditCard.creditor_name = item2?.creditor_name;
            tempCalDebtCreditCard.type_payment = item2?.type_payment;
            tempCalDebtCreditCard.pay_peryear = item2?.pay_peryear;
            tempCalDebtCreditCard.pay_permonth = item2?.pay_permonth;
            return tempCalDebtCreditCard;
          }),
        index,
        diff_age + 1
      );

      let pension_peryear =
        age < futurePlanData?.age_retire + 1
          ? 0
          : futurePlanData?.pension_peryear * 12;

      const income_peryear =
        age > futurePlanData?.age_retire
          ? 0
          : re_salary_peryear *
            (1 + futurePlanData?.salary_peryear / 100) ** index;

      const outcome_peryear =
        age > futurePlanData?.age_retire
          ? re_outcome_peryear *
            0.7 *
            (1 + futurePlanData?.out_come_peryear / 100) ** index
          : re_outcome_peryear *
            (1 + futurePlanData?.out_come_peryear / 100) ** index;

      const income_investment =
        index === 0
          ? (futurePlanData?.income_investment *
              futurePlanData?.income_investment_percent) /
            100
          : age > futurePlanData?.age_retire
          ? (prev_remain_accumulate *
              (futurePlanData?.income_investment_percent - 1)) /
            100
          : (prev_remain_accumulate *
              futurePlanData?.income_investment_percent) /
            100;

      const remain =
        income_peryear +
        pension_peryear -
        (outcome_peryear + out_come_stable * 12) -
        debt_short_list.pay_sum_alls[index] -
        debt_creditCard.pay_sum_alls[index];

      const remain_accumulate =
        index === 0
          ? futurePlanData?.income_investment +
            income_investment +
            prev_remain +
            remain
          : prev_remain_accumulate + income_investment + remain;

      if (age <= futurePlanData?.age_retire) {
        createItem = {
          index,
          age,
          income_peryear,
          outcome_peryear,
          remain,
          remain_accumulate,
          pension_peryear: 0,
          out_come_stable: out_come_stable * 12,
          outcome_total: out_come_stable * 12 + outcome_peryear,
          income_investment,
          debt_short_list,
          debt_creditCard,
        };
      } else {
        createItem = {
          index,
          age,
          income_peryear: 0,
          outcome_peryear,
          remain,
          remain_accumulate,
          pension_peryear,
          out_come_stable: out_come_stable * 12,
          outcome_total: out_come_stable * 12 + outcome_peryear,
          income_investment,
          debt_short_list,
          debt_creditCard,
        };
      }

      const itemKeys = Object.keys(createItem);

      for (const itemKey of itemKeys) {
        if (_.isNaN(createItem[itemKey])) {
          createItem[itemKey] = 0;
        }
      }

      for (const futureMoreKey of futureMoreKeys) {
        if (
          [`expenese_home_items`, `expenese_car_items`].includes(futureMoreKey)
        ) {
          const year = futurePlanData[futureMoreKey][0]?.year;
          const end_year =
            futurePlanData[futureMoreKey][0]?.year +
            futurePlanData[futureMoreKey][0]?.period -
            1;

          let item_more_amount =
            futurePlanData[futureMoreKey][0]?.sum_amount_per_period;

          if (index >= year && end_year >= index) {
            const prevItem = index === 0 ? 0 : cash_flow_items[index - 1];

            if (!prevItem?.[futureMoreKey]) {
              item_more_amount += futurePlanData[futureMoreKey][0]?.down;
            }
            createItem = {
              ...createItem,
              [futureMoreKey]: item_more_amount,
            };
          } else {
            createItem = {
              ...createItem,
              [futureMoreKey]: 0,
            };
          }
        } else {
          const year = futurePlanData[futureMoreKey][0]?.year;

          if (index === year) {
            let item_more_amount = futurePlanData[futureMoreKey]?.reduce(
              (acc, item) => {
                return acc + item?.amount;
              },
              0
            );
            createItem = {
              ...createItem,
              [futureMoreKey]: item_more_amount,
            };
          } else {
            createItem = {
              ...createItem,
              [futureMoreKey]: 0,
            };
          }
        }
      }
      cash_flow_items.push(createItem);
    }

    // console.log("cash_flow_items",cash_flow_items)

    const negativeLists = [
      "out_come_stable",
      "outcome_peryear",
      "expenese_car_items",
      "expenese_children_items",
      "expenese_travel_items",
      "expenese_collection_items",
      "expenese_other_items",
    ];
    const possitiveLists = [
      "income_legacy_items",
      "income_business_items",
      "income_property_items",
      "income_other_items",
      "income_peryear",
      "remain_accumulate",
    ];

    for (const futureMoreKey of futureMoreKeys) {
      if (negativeLists.includes(futureMoreKey)) {
        sum_expenese_total = cash_flow_items?.reduce((acc, item) => {
          return acc + item[futureMoreKey];
        }, 0);
      } else if (possitiveLists.includes(futureMoreKey)) {
        sum_income_total = cash_flow_items?.reduce((acc, item) => {
          return acc + item[futureMoreKey];
        }, 0);
      }
    }

    let sum_diff_total = sum_income_total - sum_expenese_total;

    setFuturePlanData({
      ...futurePlanData,
      sum_expenese_total,
      sum_income_total,
      sum_diff_total,
      cash_flow_keys: futureMoreKeys,
      cash_flow_items,
    });
  };

  const tempFutureData = useMemo(() => {
    if (tab === 2) {
      let copyFuturePlanData = futurePlanData;
      let calExpense = CalcAll_Expense(
        futurePlanData,
        balanceData,
        educationData,
        key_under_education
      );

      copyFuturePlanData = {
        ...copyFuturePlanData,
        cash_flow_items: calExpense,
      };

      return copyFuturePlanData;
    }
  }, [tab]);

  // console.log("tempFutureData", tempFutureData);

  const checkLengthIncomeOutcome = () => {
    let checkLength =
      futurePlanData?.expenese_home_items?.length > 0 ||
      futurePlanData?.expenese_car_items?.length > 0 ||
      futurePlanData?.expenese_children_items?.length > 0 ||
      futurePlanData?.expenese_travel_items?.length > 0 ||
      futurePlanData?.expenese_collection_items?.length > 0 ||
      futurePlanData?.expenese_other_items?.length > 0 ||
      futurePlanData?.income_legacy_items?.length > 0 ||
      futurePlanData?.income_business_items?.length > 0 ||
      futurePlanData?.income_property_items?.length > 0 ||
      futurePlanData?.income_other_items?.length > 0 ||
      futurePlanData?.expenese_children_education?.length > 0;
    return !checkLength;
    // return false
  };

  return (
    <div className={`${STYLE_SPACE_GRAY_MENU} ${STYLE_PADDING_MAIN}`}>
      {tab === 0 && <FutureStepOne />}
      {tab === 1 && <FutureStepTwo />}
      {tab === 2 && <FutureStepThree tempFutureData={tempFutureData} />}
      <div className=" flex justify-center gap-4 mb-10 px-5">
        {tab === 2 ? (
          <div className="flex space-x-[20px] ">
            <MTButton
              text="ดูรายละเอียด"
              color="border border-maincyan "
              colortext={
                displaySumary
                  ? "text-white"
                  : "text-maincyan group-hover:text-white"
              }
              hovercolor={
                displaySumary ? "bg-maincyan" : "hover:bg-maincyan group "
              }
              onClick={() => {
                setDisplaySumary(!displaySumary);
              }}
            />
            <MTButton
              text="ย้อนกลับ"
              color="border border-maincyan "
              colortext="text-maincyan group-hover:text-white"
              hovercolor="hover:bg-maincyan group "
              onClick={() => {
                if (checkLengthIncomeOutcome()) {
                  setTab((prev) => prev - 2);
                  return;
                }
                setDisplaySumary(false);
                setTab((prev) => prev - 1);
              }}
            />
          </div>
        ) : (
          <div className=" flex justify-center items-center gap-2">
            <MTButton
              text="ย้อนกลับ"
              color="border border-maincyan "
              colortext="text-maincyan group-hover:text-white"
              hovercolor="hover:bg-maincyan group "
              onClick={() => {
                if (tab === 0) {
                  setIsPlan(false);
                }

                if (checkLengthIncomeOutcome()) {
                  setTab((prev) => prev - 2);
                  return;
                }

                setDisplaySumary(false);
                setTab((prev) => prev - 1);
              }}
            />
            <MTButton
              text={"ถัดไป"}
              color="bg-maincyan"
              onClick={(e) => {
                if (tab === 0) {
                  calculateCashFlow();
                }
                if (tab === 1) {
                  calculateCashFlow();
                }

                if (checkLengthIncomeOutcome()) {
                  setTab((prev) => (tab === 2 ? false : prev + 2));
                  return;
                }

                setTab((prev) => (tab === 2 ? false : prev + 1));
              }}
            />
          </div>
        )}
      </div>
      {tab === 2 && (
        <>
          <FooterAfterSum />
        </>
      )}
      {tab === 2 && (
        <MTButton
          onClick={() => futureResultTableRef.current?.exportToExcel()}
          flexnone="flex-none"
          width="w-fit text-xs"
          text="Excel"
          iconleft
          icon={
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_6711_51468)">
                <path
                  d="M14.1733 8.54535H11.6287V7.27304H14.1733V8.54535ZM14.1733 9.27235H11.6287V10.5447H14.1733V9.27235ZM14.1733 3.27441H11.6287V4.5467H14.1733V3.27441ZM14.1733 5.27373H11.6287V6.54601H14.1733V5.27373ZM14.1733 11.2717H11.6287V12.544H14.1733V11.2717ZM15.9309 13.7799C15.8582 14.158 15.4038 14.167 15.1003 14.1798H9.44769V15.8156H8.31897L0 14.3615V1.64045L8.36806 0.18457H9.44769V1.63316H14.9058C15.213 1.64588 15.5511 1.62407 15.8182 1.80763C16.0054 2.07663 15.9873 2.41835 16 2.72732L15.9927 12.1895C15.9837 12.7184 16.0418 13.2583 15.9309 13.7799ZM6.66497 10.9282C6.16334 9.91035 5.65263 8.89976 5.15278 7.88191C5.64716 6.89135 6.13428 5.89716 6.61956 4.90295C6.20697 4.92295 5.79438 4.94838 5.38363 4.97748C5.07644 5.72448 4.71838 6.45151 4.47847 7.22398C4.25491 6.49513 3.95866 5.79354 3.68784 5.08288C3.28797 5.10469 2.88809 5.12832 2.48825 5.15195C2.90991 6.08257 3.35887 7.00038 3.76781 7.93645C3.28616 8.84523 2.83541 9.76676 2.36828 10.681C2.76631 10.6973 3.16438 10.7137 3.56241 10.7191C3.84597 9.99576 4.19856 9.29963 4.44575 8.5617C4.6675 9.35416 5.04372 10.0866 5.35272 10.8445C5.79075 10.8755 6.22694 10.9027 6.66497 10.9282ZM15.1331 2.49638H9.44769V3.27441H10.9017V4.5467H9.44769V5.27373H10.9017V6.54601H9.44769V7.27304H10.9017V8.54535H9.44769V9.27235H10.9017V10.5447H9.44769V11.2717H10.9017V12.544H9.44769V13.3845H15.1331V2.49638Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_6711_51468">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          }
        />
      )}
      {tab === 2 && (
        <div
          className={cn("min-w-screen flex justify-center mt-[32px] ", {
            hidden: !(displaySumary && tab === 2),
          })}
        >
          <FutureResultTable
            ref={futureResultTableRef}
            tab={tab}
            displaySumary={displaySumary}
            tempFutureData={tempFutureData}
          />
        </div>
      )}
    </div>
  );
};
export default FuturePlan;
